import { ApiConnector, GET, PUT } from './requestV2.service';

export default (() => {
    const APIV2 = ApiConnector('/notifications', true);
    return {
        getNotificationFranchPayment: async data => APIV2(GET, '', false, false).call(data),
        markAsRead: async data => APIV2(PUT, `/${data}/read`, false).call(),
    };
})();
